export const DynamicGenerateShape = {
    AdjustmentConstant: 10,
};
